import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import {
  UpdateRouteAgreementInput,
  UpdateRouteAgreementMutation,
  UpdateRouteAgreementMutationVariables,
} from "@/gql/graphql";
import { errorFragment } from "@/gql/GqlErrorFragment";
import {
  rateSheetTablePricesFragment,
  routeAgreementPageFragment,
} from "../gql/fragments/RouteAgreementPageFragment";

const mutation = gql`
  ${errorFragment}
  ${routeAgreementPageFragment}
  ${rateSheetTablePricesFragment}
  mutation UpdateRouteAgreement($input: UpdateRouteAgreementInput!) {
    productPrice {
      routeAgreement {
        updateRouteAgreement(input: $input) {
          __typename
          ... on ErrorResult {
            ...ErrorFragment
          }
          ... on UpdateRouteAgreementSuccessResult {
            routeAgreement {
              ...RouteAgreementPageRouteAgreement
              valid {
                start {
                  isoString
                }
              }
              prices {
                ...RateSheetTablePrices
              }
            }
          }
        }
      }
    }
  }
`;

export const useUpdateRouteAgreementMutation = () => {
  const [mutate, { loading, error }] = useMutation<
    UpdateRouteAgreementMutation,
    UpdateRouteAgreementMutationVariables
  >(mutation);
  const updateRouteAgreement = useCallback(
    (input: UpdateRouteAgreementInput) => {
      return mutate({
        variables: {
          input,
        },
      });
    },
    [mutate]
  );

  return {
    updateRouteAgreement,
    loading,
    error,
  };
};
